function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      header {\n        background-color: ", ";\n        color: ", ";\n      }\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    height: 100%;\n    header {\n      border-bottom: ", " ", " ", ";\n      border-top-left-radius: ", ";\n      border-top-right-radius: ", ";\n      padding: ", ";\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      line-height: ", ";\n    }\n\n    .scrollable {\n      overflow: auto;\n      flex: 1;\n      ", "\n    }\n\n    .messages {\n      padding: ", ";\n      overflow-y: auto;\n      overflow-x: hidden;\n      display: flex;\n      flex-shrink: 0;\n      flex-direction: column;\n    }\n\n    .no-messages {\n      text-align: center;\n    }\n\n    ", "\n    ", "\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n          font-size: 3rem;\n        "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n        border-top-", "-radius: 0;\n        border-bottom-", "-radius: 0;\n      "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: ", ";\n    border-top: ", " ", " ", ";\n    .message-row {\n      flex-direction: row;\n      display: flex;\n    }\n    input {\n      flex: 1;\n      padding: 1.25rem 1.5rem;\n      border-radius: 2rem;\n      outline: none;\n      box-sizing: border-box;\n      ", "\n    }\n\n    .send-button {\n      border-radius: 3rem;\n      border-top-", "-radius: 0;\n      border-bottom-", "-radius: 0;\n\n      ", "\n    }\n\n    .dropped-files {\n      display: flex;\n      flex-direction: row;\n      margin-bottom: 0.5rem;\n      flex-wrap: wrap;\n\n      div {\n        background-size: cover;\n        width: 3rem;\n        height: 3rem;\n        border-radius: 0.5rem;\n        margin-", ": 0.5rem;\n        margin-bottom: 0.5rem;\n        text-align: center;\n        line-height: 3rem;\n        font-size: 2rem;\n        position: relative;\n\n        .remove {\n          position: absolute;\n          right: -0.5rem;\n          top: -0.875rem;\n          font-size: 0.875rem;\n          line-height: 1;\n          cursor: pointer;\n        }\n      }\n    }\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      .message {\n        margin-", ": 0.5rem;\n        margin-", ": 3rem;\n      }\n      ", " {\n        align-items: flex-start;\n        .text {\n          border-top-", "-radius: 0;\n          background: ", ";\n          color: ", ";\n        }\n      }\n      ", " {\n        align-items: flex-start;\n      }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      flex-direction: row-reverse;\n      .message {\n        margin-", ": 0.5rem;\n        margin-", ": 3rem;\n      }\n      ", " {\n        align-items: flex-end;\n        .sender {\n          text-align: ", ";\n        }\n        .text {\n          border-top-", "-radius: 0;\n          background: ", ";\n          color: ", ";\n        }\n      }\n      ", " {\n        align-items: flex-start;\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 1.5rem;\n    display: flex;\n    flex-direction: row;\n    .message {\n      flex: 1;\n    }\n    .avatar {\n      border-radius: 50%;\n      flex-shrink: 0;\n      background: ", ";\n      background-size: 3.4rem 2.6rem;\n      background: no-repeat center;\n      width: 2.5rem;\n      height: 2.5rem;\n      text-align: center;\n      line-height: 2.5rem;\n      font-size: 0.875rem;\n      color: white;\n    }\n    ", "\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    p.quote {\n      font-style: italic;\n      font-size: 0.875rem;\n      background: ", ";\n      color: ", ";\n      padding: 1rem;\n      border-radius: 0.5rem;\n      margin-bottom: 0.5rem;\n    }\n    .sender {\n      font-size: 0.875rem;\n      color: ", ";\n      margin-bottom: 0.5rem;\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    a {\n      color: ", ";\n        background: ", ";\n      font-size: 4rem;\n      text-align: center;\n      border: 1px solid ", ";\n      width: 10rem;\n      height: 10rem;\n      overflow: hidden;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-shrink: 0;\n      border-radius: 0.5rem;\n      &:hover,\n      &:focus {\n        text-decoration: none;\n        color: ", ";\n      }\n      div {\n        background-size: cover;\n        width: 100%;\n        height: 100%;\n      }\n    }\n    ", " {\n      display: block;\n      margin-bottom: 0.5rem;\n    }\n    .message-content-group {\n      display: flex;\n      flex-direction: row;\n      justify-content: flex-end;\n      flex-wrap: wrap;\n      a {\n        margin-", ": 1rem;\n        margin-bottom: 1rem;\n        width: 5rem;\n        height: 5rem;\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    .sender {\n      font-size: 0.875rem;\n      color: ", ";\n      margin-bottom: 0.5rem;\n    }\n    p {\n      word-wrap: break-word;\n      word-break: break-all;\n      max-width: 100%;\n      margin: 0;\n    }\n    .text {\n      padding: 1rem;\n      border-radius: 0.5rem;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled, { css } from 'styled-components';
import { scrollbars } from '../utils';
var MessageTextStyle = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2(), theme.chatMessageSenderTextColor);
});
var MessageFileStyle = styled.div(_templateObject3(), function (_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject4(), theme.chatMessageFileTextColor, theme.chatMessageFileBackgroundColor, theme.chatMessageFileTextColor, theme.chatMessageFileTextColor, MessageTextStyle, theme.dir === 'rtl' ? 'left' : 'right');
});
var MessageQuoteStyle = styled.div(_templateObject5(), function (_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject6(), theme.chatMessageQuoteBackgroundColor, theme.chatMessageQuoteTextColor, theme.chatMessageSenderTextColor);
});
var MessageStyle = styled.div(_templateObject7(), function (_ref4) {
  var theme = _ref4.theme,
      reply = _ref4.reply;
  return css(_templateObject8(), theme.chatMessageAvatarBackgroundColor, reply ? css(_templateObject9(), theme.dir === 'rtl' ? 'left' : 'right', theme.dir === 'rtl' ? 'right' : 'left', MessageTextStyle, theme.dir === 'rtl' ? 'left' : 'right', theme.dir === 'rtl' ? 'left' : 'right', theme.chatMessageReplyBackgroundColor, theme.chatMessageReplyTextColor, MessageFileStyle) : css(_templateObject10(), theme.dir === 'rtl' ? 'right' : 'left', theme.dir === 'rtl' ? 'left' : 'right', MessageTextStyle, theme.dir === 'rtl' ? 'right' : 'left', theme.chatMessageBackground, theme.chatMessageTextColor, MessageFileStyle));
});
var FormStyle = styled.div(_templateObject11(), function (_ref5) {
  var theme = _ref5.theme,
      showButton = _ref5.showButton,
      buttonIcon = _ref5.buttonIcon;
  return css(_templateObject12(), theme.chatPadding, theme.chatDividerWidth, theme.chatDividerStyle, theme.chatDividerColor, showButton && css(_templateObject13(), theme.dir === 'rtl' ? 'left' : 'right', theme.dir === 'rtl' ? 'left' : 'right'), theme.dir === 'rtl' ? 'right' : 'left', theme.dir === 'rtl' ? 'right' : 'left', buttonIcon && css(_templateObject14()), theme.dir === 'rtl' ? 'left' : 'right');
});
var ChatStyle = styled.div(_templateObject15(), function (_ref6) {
  var theme = _ref6.theme,
      size = _ref6.size,
      status = _ref6.status;
  return css(_templateObject16(), theme.chatBackgroundColor, theme.chatBorder, theme.chatBorderRadius, theme.chatShadow, theme.chatTextColor, theme.chatTextFontFamily, theme.chatTextFontSize, theme.chatTextFontWeight, theme.chatTextLineHeight, theme.chatDividerWidth, theme.chatDividerStyle, theme.chatDividerColor, theme.chatBorderRadius, theme.chatBorderRadius, theme.chatPadding, theme.chatHeaderTextFontFamily, theme.chatHeaderTextFontSize, theme.chatHeaderTextFontWeight, theme.chatHeaderTextLineHeight, scrollbars(theme.chatScrollbarColor, theme.chatScrollbarBackgroundColor, theme.chatScrollbarWidth), theme.chatPadding, size && "height: ".concat(theme["chat".concat(size, "Height")], ";"), status && css(_templateObject17(), theme["chat".concat(status, "BackgroundColor")], theme["chat".concat(status, "TextColor")]));
});
export { ChatStyle, FormStyle, MessageStyle, MessageFileStyle, MessageQuoteStyle, MessageTextStyle };